import { render, staticRenderFns } from "./CollapseQuestions.vue?vue&type=template&id=83f6e4cc&scoped=true&"
import script from "./CollapseQuestions.vue?vue&type=script&lang=js&"
export * from "./CollapseQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CollapseQuestions.vue?vue&type=style&index=0&id=83f6e4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f6e4cc",
  null
  
)

export default component.exports